import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

const TABS = [
  { to: "/settings", label: "Business", exact: true },
  { to: "/settings/hours", label: "Hours", exact: false },
  { to: "/settings/scheduling", label: "Scheduling", exact: false },
  { to: "/settings/closures", label: "Closures", exact: false },
  { to: "/settings/locations", label: "Locations", exact: false },
  { to: "/settings/notifications", label: "Customer messages", exact: false },
  { to: "/settings/payments", label: "Payments", exact: false },
  { to: "/settings/invoicing", label: "Quotes and invoices", exact: false },
  { to: "/settings/plan", label: "Plan and billing", exact: false },
  { to: "/settings/booking", label: "Online booking", exact: false },
  { to: "/settings/data", label: "Your data", exact: false },
] as const;

/** Settings hub: each tab is its own screen with its own help guide. */
export const Route = createFileRoute("/_app/settings")({
  component: () => (
    <div className="mx-auto max-w-3xl">
      <nav className="mb-6 flex flex-wrap gap-2" aria-label="Settings sections">
        {TABS.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            activeOptions={{ exact: t.exact }}
            className="rounded-full border border-line px-3 py-1.5 text-sm text-muted hover:bg-brand-50"
            activeProps={{ className: "border-brand-600 bg-brand-50 font-semibold text-brand-700" }}
          >
            {t.label}
          </Link>
        ))}
      </nav>
      <Outlet />
    </div>
  ),
});
